export function Occupation(a) {
  return {
    type: 'OCCUPATION',
    payload: {
      occupation: a,
    },
  };
}
